module.exports = __webpack_public_path__ + "img/low-cost-house-2.8cdb1208.jpg";